import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid2';
import RenderFormElement from './RenderFormElement';
import DynamicForm, { IDynamicForm, IDynamicFormElement } from './DynamicForm';
import { useDispatch } from 'react-redux';
import { createOrUpdateElementData } from './formsSlice';
import AlertElement from '../AlertElement';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
    name: string,
    customHandleOnChange?: (id: string, value: any) => void
}

export default function GenerateForm(props: IProps) {

    const { name, customHandleOnChange } = props

    const form = DynamicForm.useReturnSingleForm(name)
    const data = DynamicForm.useReturnAllFormsData()

    const elements = form.elements

    const dispatch = useDispatch()

    const handleOnChange = (id: string, value: any) => {

        if (typeof value === "object"){
            if (value.value){
                value = value.value
            }
        }

        if (customHandleOnChange){
            customHandleOnChange(id, value)
        }else{
            dispatch(createOrUpdateElementData({
                name: id,
                value: value
            }))
        }
    }

    return(
        <div className="dynamic-form-container">
            <div className="content-of-dynamic-form-container">

                <div className={form.loading ? "loading-box-of-dynamic-form-container active" : "loading-box-of-dynamic-form-container"}>
                    <div className="content-of-loading-box-of-dynamic-form-container">
                        <CircularProgress />
                    </div>
                </div>

                <form>
                    <Grid container spacing={1}>
                        {elements.map((element: IDynamicFormElement, index: number) => <Grid key={index} size={{ xs: element.xs }}><RenderFormElement element={element} handleOnChange={handleOnChange}/></Grid>)}
                    </Grid>
                </form>

                {form.message && form.message.shown && (
                    <div className="message-box-of-dynamic-form-container">
                        <div className="content-of-message-box-of-dynamic-form-container">
                            <AlertElement type={form.message.type} message={form.message.message} />
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}